import { Chip } from '@nexelem/components';
import { cn } from '@nexelem/utils';
import { startOfDay, add } from 'date-fns';
import { useTranslation } from 'react-i18next';

export type DateBadge = {
  value: number;
  type: keyof Duration;
};

type DateBadgesProps = {
  badges: DateBadge[];
  onChange: (value: Date) => void;
};

export const DateBadges = ({ badges, onChange }: DateBadgesProps) => {
  const { t } = useTranslation();
  return (
    <div className={cn('flex gap-2')}>
      {badges.map(({ type, value }) => {
        const badgeValue = startOfDay(add(new Date(), { [type]: value }));
        return (
          <Chip
            key={`${type}-${value}`}
            label={t(`components.datePicker.badges.${type}`, { count: value })}
            onChange={() => onChange(badgeValue)}
          />
        );
      })}
    </div>
  );
};
